module.exports = __webpack_public_path__ + "static/media/612.ac85fb80.png";